<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section>
                <div class="accountsReceive">
                    <div class="search-conditions-con">
                        <van-radio-group v-model="radio" direction="horizontal" @change="switchingTimeNodes">
                            <van-radio name="date">
                                按日
                                <template #icon="props">
                                    <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                                </template>
                            </van-radio>
                            <van-radio name="naturalMonth">
                                按月
                                <template #icon="props">
                                    <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                                </template>
                            </van-radio>
                            <van-radio name="month">
                                按财务月
                                <template #icon="props">
                                    <i class="iconfont" :class="props.checked ? 'sm-danxuan_': 'sm-danxuan'"></i>
                                </template>
                            </van-radio>
                        </van-radio-group>
                        <div v-if="radio === 'month'" class="search-conditions-month iconfont sm-rili" @click="handleShowDatePop('month')">
                            <span>{{ month }}</span>
                        </div>
                        <div v-if="radio === 'naturalMonth'" class="search-conditions-month iconfont sm-rili" @click="handleShowDatePop('naturalMonth')">
                            <span>{{ naturalMonth }}</span>
                        </div>
                    </div>
                    <div v-if="radio === 'date'" class="search-conditions-day">
                        <span class="time-con" @click="handleShowDatePop('start_date')">
                            <i class="iconfont sm-rili"></i>
                            <span>{{ start_date }}</span>
                        </span>
                        <span>—</span>
                        <span class="time-con" @click="handleShowDatePop('end_date')">
                            <i class="iconfont sm-rili"></i>
                            <span>{{ end_date }}</span>
                        </span>
                    </div>
                    <div class="main">
                        <div class="top">
                            <div class="header">
                                <div class="headerList">
                                    <template v-for="(item, index) in aggregatedData">
                                        <div class="item" :class="{'item_active': index === activeIndex}" :key="`aggregatedList_${index}`" @click="selectHeader(index)">
                                            <p class="describe">
                                                {{ item.name }}
                                            </p>
                                            <p class="num">
                                                {{ aggregatedVal[item.key] || 0 }}
                                            </p>
                                        </div>
                                    </template>
                                </div>
                                <div class="headerList">
                                    <template v-for="(k, j) in comprehensiveQuality">
                                        <div class="item" :key="`comprehensiveQualityList_${j}`">
                                            <p class="describe">
                                                {{ k.name }}
                                            </p>
                                            <p class="num">
                                                {{ comprehensiveQualityVal[k.key] || 0 }}
                                            </p>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="chart-con">
                            <!-- <div class="btn_box">
                                <van-radio-group @change="tabTypeChangeFun" v-model="tabTypeVal" direction="horizontal">
                                    <van-radio name="list_zfm">
                                        正负目
                                    </van-radio>
                                    <van-radio name="list_thl">
                                        碳含量
                                    </van-radio>
                                </van-radio-group>
                            </div> -->
                            <div id="recovery-chart"></div>
                        </div>
                        <div class="list_head_box">
                            <table border>
                                <thead>
                                    <tr>
                                        <th>品种</th>
                                        <th>数量（吨）</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item, index) in tableData">
                                        <tr :key="`cost_${index}`" :class="{tr_shallow: index % 2 === 0, tr_deep: index % 2 !== 0}">
                                            <td align="center">
                                                {{ item.name }}
                                            </td>
                                            <td align="center">
                                                {{ item.nub }}
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <van-popup v-model="showDatePop" position="bottom" :style="{ height: '50%' }">
                        <van-datetime-picker
                            v-model="date2Model"
                            :type="radio === 'date' ? 'date' : 'year-month'"
                            title="选择年月"
                            @confirm="confirmDate"
                            @cancel="showDatePop=false"
                        ></van-datetime-picker>
                    </van-popup>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>
import util from '@/assets/js/utils';
import currencyFun from '@/assets/js/currencyFun/index.js';
export default {
    components: {},
    props: {},
    data() {
        return {
            pagedata: {},
            navData: {
                title: '生产日报（鸡西）',
                leftText: '',
                rightText: '',
                leftArrow: true,
            },
            aggregatedData: [{
                name: '合计',
                key: 'total_production',
            }, {
                name: '一选厂',
                key: 'first_factory_production',
            }, {
                name: '二选厂',
                key: 'second_factory_production',
            }, {
                name: '三选厂',
                key: 'third_factory_production',
            }],
            aggregatedVal: {},
            comprehensiveQuality: [{
                name: '综合质量',
                key: 'total_quality',
            }, {
                key: 'first_factory_quality',
            }, {
                key: 'second_factory_quality',
            }, {
                key: 'third_factory_quality',
            }],
            comprehensiveQualityVal: {},
            activeIndex: 0,
            activeKey: 'total_production',
            // 唤起日期选择的日期key
            dateKey: '',
            tableData: [],
            showDatePop: false,
            listData: [], // 列表数据
            // 当前日期
            start_date: '',
            end_date: '',
            month: '', // 选择月份
            naturalMonth: '', // 自然月
            radio: 'date', // 选择日期还是月份模式
            month_start_date: '',
            month_end_date: '',
            date2Model: '',

            // tabTypeVal: 'list_zfm',/
            time: {
                s: '',
                e: '',
            }, // 选择月份模式的开始结束日期
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        // 切换类型.
        // tabTypeChangeFun() {
        //     this.loadData();
        // },
        async init() {
            this.start_date = util.theOtherDayTimeFormat('yyyy-MM-dd', 1);
            this.end_date = util.theOtherDayTimeFormat('yyyy-MM-dd', 1);
            this.month = currencyFun.timeFormat(new Date(), 'yyyy-MM');
            this.naturalMonth = currencyFun.timeFormat(new Date(), 'yyyy-MM');
            if (this.radio === 'naturalMonth') {
                this.timeFormatNatureMonth(this.naturalMonth);
            } else {
                this.timeFormatMonth(this.month);
            }
            this.getData();
        },
        // 点击日期，唤起日期选择
        handleShowDatePop(key) {
            this.dateKey = key;
            this.date2Model = new Date(this[key]);
            this.showDatePop = true;
        },
        // 选择月份时 处理日期 每月数据周期为上月25日（含）到本月24日（含）
        timeFormatMonth(month) {
            // 1月份时，为上一年的12月25-下一年1月24
            // 其他为 每月数据周期为上月25日（含）到本月24日（含）
            const y = month.split('-')[0];
            let m = month.split('-')[1];
            if (m <= 1) {
                this.time.s = y + '-01-01';
                this.time.e = y + '-01-24';
            } else if (m === '12') {
                this.time.s = y + '-11-24';
                this.time.e = y + '-12-31';
            } else {
                m -= 1;
                this.time.s = y + '-' + m + '-25';
                this.time.e = y + '-' + (m + 1) + '-24';
            }
        },
        // 自然月时间处理
        timeFormatNatureMonth(month) {
            const m = month.split('-')[1];
            const firstDate = new Date(month);
            firstDate.setDate(1);
            const endDate = new Date(firstDate);
            endDate.setMonth(firstDate.getMonth() + 1);
            endDate.setDate(0);
            this.time.s = util.timeFormat(firstDate, 'yyyy-MM-dd');
            const today = new Date();
            if (today.getMonth() + 1 === Number(m)) {
                this.time.e = util.timeFormat(new Date(), 'yyyy-MM-dd');
            } else {
                this.time.e = util.timeFormat(endDate, 'yyyy-MM-dd');
            }
        },
        // 时间节点切换
        switchingTimeNodes(val) {
            this.radio = val;
            this.init();
        },
        confirmDate(value) {
            this[this.dateKey] = util.timeFormat(value, 'yyyy-MM');
            if (this.radio === 'month') {
                this.month = currencyFun.timeFormat(value, 'yyyy-MM');
                this.timeFormatMonth(this.month);
            } else if (this.radio === 'naturalMonth') {
                this.naturalMonth = currencyFun.timeFormat(value, 'yyyy-MM');
                this.timeFormatNatureMonth(this.naturalMonth);
            }
            this.getData();
            this.showDatePop = false;
        },

        selectHeader(index) {
            this.activeIndex = index;
            this.activeKey = this.aggregatedData[index].key;
            this.loadData(this.aggregatedData[index]);
        },

        // 获取数据
        getData() {
            this.$toast.loading({ overlay: true, duration: 0 });
            let sDate = '';
            let eDate = '';
            if (this.radio === 'date') {
                sDate = this.start_date;
                eDate = this.end_date;
            } else {
                sDate = this.time.s;
                eDate = this.time.e;
            }
            const path = `/interfaceApi/report/report/graphite/production/day_report/${sDate}?end_date=${eDate}`;
            return this.$axios.get(path).then(res => {
                if (res) {
                    const last = res.details.pop();
                    res.details.unshift(last);
                    this.pagedata = res;
                    this.loadData();
                }
                this.$toast.clear();
            });
        },

        loadData() {
            this.tableData = [];
            this.aggregatedVal = this.pagedata.total;
            this.comprehensiveQualityVal = this.pagedata.comprehensiveQuality;
            (this.pagedata.details || []).forEach(item => {
                this.tableData.push({
                    name: item.group_name,
                    nub: item[this.activeKey],
                });
            });
            const cahrtData = [];
            (this.pagedata.list_grade || []).forEach(item => {
                cahrtData.push({
                    name: item.group_name,
                    value: item[this.activeKey] ? Number(item[this.activeKey]) : 0,
                });
            });
            this.pieChart('recovery-chart', cahrtData);
        },

        pieChart(obj, data) {
            const chart = window.$globalHub.$echarts.init(document.getElementById(obj));
            // 默认渐变颜色
            const colors = [
                ['#6D6B7B', '#6D6B7B'],
                ['#ED6967', '#ED6967'],
                ['#5D7092', '#5D7092'],
            ];
            let total = 0;
            data.forEach(item => {
                total += item.value;
            });
            data.forEach(item => {
                if (total === 0) {
                    item.name += '(0%)';
                } else {
                    item.name += '(' + (Number(item.value) / total * 100).toFixed(1) + '%)';
                }
            });
            const result = [];
            data.forEach((item, index) => {
                const obj = {
                    value: item.value,
                    name: item.name,
                    label: {
                        alignTo: 'edge',
                        formatter: '{name|{b}} \n{value|{c}吨}',
                        minMargin: 5,
                        edgeDistance: 12,
                        lineHeight: 18,
                        rich: {
                            name: {
                                fontSize: 11,
                                color: '#666',
                            },
                            value: {
                                fontSize: 11,
                                color: '#666',
                            },
                        },
                    },
                };
                if (index < colors.length) {
                    obj.itemStyle = {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: colors[index][0], // 0% 处的颜色
                            }, {
                                offset: 1, color: colors[index][1], // 100% 处的颜色
                            }],
                            global: false, // 缺省为 false
                        },
                    };
                }
                result.push(obj);
            });
            const option = {
                title: {
                    text: '统计图',
                    left: 'left',
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '60%'],
                        center: ['50%', '60%'],
                        selectedMode: 'single',
                        data: result,
                        itemStyle: {
                            borderRadius: 2,
                            borderColor: '#fff',
                            borderWidth: 2,
                        },
                        labelLayout: function (params) {
                            const isLeft = params.labelRect.x < chart.getWidth() / 2;
                            const points = params.labelLinePoints;
                            // Update the end point.
                            points[2][0] = isLeft
                                ? params.labelRect.x
                                : params.labelRect.x + params.labelRect.width;

                            return {
                                labelLinePoints: points,
                            };
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                ],
            };
            chart.setOption(option);
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
    },
};
</script>
<style lang="stylus" scoped>
.container
    height 100%
    section
        height calc(100% - 68rpx)
        overflow-y: scroll
        .accountsReceive
            background #fff
            width 100%
            height 100%
            .charts_header
                margin 12rpx 30rpx
                .van-tabs__nav
                    margin 0
            .search-conditions-con
                height: 13.8667vw;
                background: #f8f8f8;
                border-bottom: 1px solid #f0f0f0;
                padding: 0 3.7333vw;
                display: -webkit-flex;
                display: flex;
                -webkit-justify-content: space-between;
                justify-content: space-between;
                -webkit-align-items: center;
                align-items: center;
                .search-conditions-month
                    width 120rpx
                    height 32rpx
                    line-height: 30rpx
                    background: #F0F0F0;
                    border-radius: 4px;
                    border: 1px solid #D7D7D7;
                    font-size 14rpx
                    color #343434
                    text-align: center
                    position: relative
                    padding 0
                    padding-left: 20rpx
                    &:before
                        position: absolute
                        top 0
                        left 10rpx
            .search-conditions-day
                margin 10rpx 0
                font-size: 4.2667vw;
                height: 12vw;
                box-shadow: 1px 1px 4px 0px rgba(0,0,0,0.2);
                border-radius: 1.0667vw;
                padding: 2.6667vw 5.3333vw;
                display: -webkit-flex;
                display: flex;
                -webkit-justify-content: space-around;
                justify-content: space-around;
                line-height: 6.6667vw;
                background: #f0f0f0;
            .main
                .top
                    padding 0 10rpx 10rpx 10rpx
                    h4
                        margin-top 10rpx
                        span
                            font-size 12rpx
                            color #979EA7
                    .header
                        border-radius 4rpx
                        overflow hidden
                        .headerList
                            display flex
                            flex-wrap wrap
                            background repeating-linear-gradient(to left, #F79187, #EA5D5D)
                            padding 5px
                            &:nth-of-type(2)
                                margin-top 2rpx
                                background: linear-gradient( 270deg, #918F9E 0%, #6D6B7B 100%);
                                .item
                                    &:first-child
                                        position relative
                                        &:after
                                            background: #918F9E
                            .item
                                flex 1
                                text-align center
                                padding 2rpx
                                color #fff
                                display flex
                                flex-direction column
                                justify-content center
                                .describe
                                    font-size 12rpx
                                    line-height 16rpx
                                    white-space nowrap
                                .num
                                    font-size 20rpx
                                    line-height: 26rpx
                                &:first-child
                                    position relative
                                    .describe
                                        font-size 14rpx
                                    .num
                                        font-size 22rpx
                                    &:after
                                        content ''
                                        height: 40rpx
                                        width 1px
                                        background: #FC8785
                                        position: absolute
                                        right 0
                                        top 50%
                                        margin-top -20rpx
                                &.item_active
                                    border-radius 4rpx
                                    background: rgba(255,255,255,0.2)
                .chart-con
                    height: 320rpx
                    padding 10rpx
                    position relative
                    #recovery-chart
                        height 265rpx
                    .btn_box
                        position absolute
                        left 90rpx
                        top 13rpx
                        z-index 99
                        .xs_btn
                            margin-left 5rpx
                .list_head_box
                    padding: 12rpx
                    table
                        width 100%
                        border-collapse collapse
                        border-color #f4f4f4
                        max-height 100%
                        thead
                            background #FBEEEE
                            border-bottom 1px solid #bebebe
                        tr
                            width 100%
                            height 36rpx
                            line-height 36rpx
                            th
                                font-weight 540
                                color #000
                            th, td
                                color #343434
                                width 50%
                                border-color #f4f4f4
                                padding 0 4rpx
                                border 1px solid #E4E4E4
</style>
